import Navbar from '../Components/Navbar';
import PageHeader from '../Components/PageHeader';
import Footer from '../Components/Footer';
import erp1 from '../assets/erp1.jpg'
import erp2 from '../assets/erp2.png'
import erp3 from '../assets/erp3.jpeg'
import erp4 from '../assets/erp4.png'
import { Link } from 'react-router-dom';

const ERP = () => {
    return (
        <div>
            <Navbar />
            <PageHeader 
                title="Our ERP Services" 
                subtitle="Smart ERP solutions to manage and optimize your business operations in one place." 
            />

            <section className="py-16 px-6 bg-white">
                <div className="container mx-auto space-y-20">

                    {/* SECTION 1 */}
                    <div className="grid md:grid-cols-2 gap-10 items-center">
                        {/* TEXT */}
                        <div>
                            <h2 className="text-3xl md:text-4xl font-bold mb-4 text-netbernet-black">
                            ERP for Residential Communities
                            </h2>
                            <p className="text-gray-600 text-lg leading-relaxed">
                            Simplify and digitize residential society operations with a centralized ERP platform designed for modern community management. From maintenance billing and payment tracking to complaint handling and resident communication, the system automates routine tasks and ensures complete transparency. With role-based access for admins, treasurers, and residents, along with real-time notifications, it enhances efficiency, reduces manual errors, and improves the overall living experience within the community.
                            </p>
                            <ul className="mt-4 space-y-2 text-gray-600">
                                <li className="flex items-start">
                                    <span className="text-netbernet-blue mr-2">•</span>
                                    <span>Maintenance Billing & Payment Tracking</span>
                                </li>
                                <li className="flex items-start">
                                    <span className="text-netbernet-blue mr-2">•</span>
                                    <span>Complaint & Ticket Management System</span>
                                </li>
                                <li className="flex items-start">
                                    <span className="text-netbernet-blue mr-2">•</span>
                                    <span>Resident & Property Management</span>
                                </li>
                            </ul>
                        </div>

                        {/* IMAGE */}
                        <div className="w-full aspect-[4/3] md:aspect-[16/8] overflow-hidden rounded-xl shadow-lg">
                            <img
                                src={erp1}
                                alt="ERP"
                                className="w-full h-full object-cover"
                            />
                        </div>
                    </div>

                    {/* SECTION 2 */}
                    <div className="grid md:grid-cols-2 gap-10 items-center">
                        {/* IMAGE */}
                        <div className="w-full aspect-[4/3] md:aspect-[16/8] overflow-hidden rounded-xl shadow-lg">
                            <img
                                src={erp2}
                                alt="ERP"
                                className="w-full h-full object-cover"
                            />
                        </div>

                        {/* TEXT */}
                        <div>
                            <h2 className="text-3xl md:text-4xl font-bold mb-4 text-netbernet-black">
                            ERP for Educational Institutions
                            </h2>
                            <p className="text-gray-600 text-lg leading-relaxed">
                            Transform academic and administrative processes with a comprehensive school management ERP system that integrates all core operations into a single intelligent platform. From student admissions and attendance tracking to fee management, examinations, and parent communication, the system ensures seamless coordination across departments. With secure access, real-time updates, and mobile compatibility, it improves productivity, enhances transparency, and enables data-driven decision-making for institutions.
                            </p>
                            <ul className="mt-4 space-y-2 text-gray-600">
                                <li className="flex items-start">
                                    <span className="text-netbernet-blue mr-2">•</span>
                                    <span>Student Information & Admission Management</span>
                                </li>
                                <li className="flex items-start">
                                    <span className="text-netbernet-blue mr-2">•</span>
                                    <span>Attendance, Timetable & Examination Systems</span>
                                </li>
                                <li className="flex items-start">
                                    <span className="text-netbernet-blue mr-2">•</span>
                                    <span>HR, Payroll & Fee Management</span>
                                </li>
                            </ul>
                        </div>
                    </div>

                    {/* SECTION 3 */}
                    <div className="grid md:grid-cols-2 gap-10 items-center">
                        {/* TEXT */}
                        <div>
                            <h2 className="text-3xl md:text-4xl font-bold mb-4 text-netbernet-black">
                            ERP for Logistics & Freight Management
                            </h2>
                            <p className="text-gray-600 text-lg leading-relaxed">
                            Optimize logistics operations with a powerful ERP system designed to manage the entire freight lifecycle—from quotation and booking to shipment tracking and delivery. The system centralizes operational data, automates documentation, and provides real-time visibility into shipments, performance metrics, and logistics workflows. With advanced reporting and analytics, businesses can improve efficiency, reduce delays, and make informed decisions to streamline supply chain operations.
                            </p>
                            <ul className="mt-4 space-y-2 text-gray-600">
                                <li className="flex items-start">
                                    <span className="text-netbernet-blue mr-2">•</span>
                                    <span>Quotation, Booking & Shipment Management</span>
                                </li>
                                <li className="flex items-start">
                                    <span className="text-netbernet-blue mr-2">•</span>
                                    <span>Real-Time Tracking & Operational Visibility</span>
                                </li>
                                <li className="flex items-start">
                                    <span className="text-netbernet-blue mr-2">•</span>
                                    <span>Reporting, Analytics & Performance Monitoring</span>
                                </li>
                            </ul>
                        </div>

                        {/* IMAGE */}
                        <div className="w-full aspect-[4/3] md:aspect-[16/8] overflow-hidden rounded-xl shadow-lg">
                            <img
                                src={erp3}
                                alt="ERP"
                                className="w-full h-full object-cover"
                            />
                        </div>
                    </div>

                     {/* SECTION 4 */}
                    <div className="grid md:grid-cols-2 gap-10 items-center">
                        {/* IMAGE */}
                        <div className="w-full aspect-[4/3] md:aspect-[16/8] overflow-hidden rounded-xl shadow-lg">
                            <img
                                src={erp4}
                                alt="ERP"
                                className="w-full h-full object-cover"
                            />
                        </div>

                        {/* TEXT */}
                        <div>
                            <h2 className="text-3xl md:text-4xl font-bold mb-4 text-netbernet-black">
                            Custom ERP Solutions
                            </h2>
                            <p className="text-gray-600 text-lg leading-relaxed">
                            Get fully customized ERP systems tailored to your business needs. Automate workflows,
          improve productivity, and ensure seamless integration with your existing tools.
                            </p>
                        </div>
                    </div>

                </div>
                </section>

            {/* CTA Section */}
            <section className="py-16 px-6 bg-netbernet-blue text-netbernet-white text-center">
                <div className="container mx-auto">
                <h2 className="text-3xl md:text-4xl font-bold mb-6">Ready to Get Started?</h2>
                <p className="text-xl mb-10 max-w-3xl mx-auto">
                    Contact us today to discuss your project requirements and get a free consultation.
                </p>
                <Link to="/contact" className="bg-netbernet-white text-netbernet-blue px-8 py-4 rounded-lg font-semibold hover:bg-blue-100 transition-colors inline-block">
                    Contact Us Now
                </Link>
                </div>
            </section>

            <Footer />
        </div>
    );
};

export default ERP;